import { Injectable, inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslationService } from './translation.service';

@Injectable({
  providedIn: 'root'
})
export class ToastMessageService {
  private translationService = inject(TranslationService);

  constructor(
    private _MessageService: MessageService
  ) { }

  /**
   * Translates a string if it's a translation key (contains dot), otherwise returns as is
   */
  private translateIfKey(text: string): string {
    if (!text) return text;
    // If it contains a dot, treat it as a translation key
    if (text.includes('.')) {
      return this.translationService.translate(text);
    }
    // Otherwise, try to translate common words
    const commonKeys: { [key: string]: string } = {
      'success': 'toast.success',
      'error': 'toast.error',
      'Success': 'toast.success',
      'Error': 'toast.error'
    };
    const key = commonKeys[text];
    if (key) {
      return this.translationService.translate(key);
    }
    return text;
  }

  public toastOnSuccess(title: string, message: string) {
    this._MessageService.add({
      severity: 'success',
      summary: this.translateIfKey(title),
      detail: this.translateIfKey(message)
    })
  }

  public toastOnError(title: string, message: string) {
    this._MessageService.add({
      severity: 'error',
      summary: this.translateIfKey(title),
      detail: this.translateIfKey(message)
    })
  }

}
